import React from 'react';
import PropTypes from 'prop-types';
import { useFormFieldValue } from 'packages/form';
import RequestAvailableAudience from 'components/Campaign/RequestAvailableAudience';

// import styled from 'styled-components';

function AvailableAudience({ campaignId, channel }) {
  const filters = useFormFieldValue('filters');

  return <RequestAvailableAudience campaignId={campaignId} channel={channel} filters={filters} />;
}

AvailableAudience.propTypes = {
  campaignId: PropTypes.number.isRequired,
  channel: PropTypes.oneOf(['email', 'sms']).isRequired,
  filters: PropTypes.array
};

export default AvailableAudience;
